<template>
  <div class="container">
    <!-- Tile 1: Lesson Plan -->
    <div class="tile">
      <h4>
        Lesson Plan
        <i
          class="far fa-edit"
          v-if="!isLessonPlanEditable"
          style="font-size: 16px; color: #007bff; cursor: pointer;"
          @click="toggleLessonPlanEdit"
        ></i>
      </h4>
      <div class="field" v-for="(field, index) in lessonPlanFields" :key="'lp' + index">
        <input
          type="checkbox"
          :id="'lp-' + field.key"
          v-model="lessonplan[field.key]"
          :disabled="!isLessonPlanEditable"
          @change="onLessonPlanChange(field.key)"
        >
        <label :for="'lp-' + field.key">{{ field.label }}</label>
      </div>
      <div class="text-right mt-2" v-if="isLessonPlanEditable">
        <b-button size="sm" variant="primary" class="mr-2" @click="setLessonPlan">Update</b-button>
        <b-button size="sm" variant="secondary" @click="cancelLessonPlanEdit">Cancel</b-button>
      </div>
    </div>

    <!-- Tile 2: Course Coverage -->
    <div class="tile mt-4">
      <h4>
        Course Coverage
        <i
          class="far fa-edit"
          v-if="!isCourseCoverageEditable"
          style="font-size: 16px; color: #007bff; cursor: pointer;"
          @click="toggleCourseCoverageEdit"
        ></i>
      </h4>
      <div class="field" v-for="(field, index) in courseCoverageFields" :key="'cc' + index">
        <input
          type="checkbox"
          :id="'cc-' + field.key"
          v-model="coursecoverage[field.key]"
          :disabled="!isCourseCoverageEditable"
        >
        <label :for="'cc-' + field.key">{{ field.label }}</label>
      </div>
      <div class="text-right mt-2" v-if="isCourseCoverageEditable">
        <b-button size="sm" variant="primary" class="mr-2" @click="setCourseCoverage">Update</b-button>
        <b-button size="sm" variant="secondary" @click="cancelCourseCoverageEdit">Cancel</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["usergroup_id"],
  async created() {
    await this.getCourseFileHeaderLessonPlan();
    await this.getCourseFileHeaderCourseCoverage();
  },
  data() {
    return {
      lessonplan: {},
      coursecoverage: {},
      isLessonPlanEditable: false,
      isCourseCoverageEditable: false,
      backupLessonPlan: {},
      backupCourseCoverage: {},

      defaultLessonPlan: {
        planned_session: false,
        delivery_method: false,
        po: false,
        pso: false,
        bloom: false,
        sdg: false,
      },
      defaultCourseCoverage: {
        planned_date: true,
        planned_session: false,
        delivery_method: false,
        po: false,
        pso: false,
        bloom: false,
        sdg: false,
      },
      lessonPlanFields: [
        { key: 'planned_session', label: 'Planned Session' },
        { key: 'delivery_method', label: 'Delivery Method Plan' },
        { key: 'po', label: 'Programme Outcome' },
        { key: 'pso', label: 'Programme Specific Outcome' },
        { key: 'bloom', label: 'Blooms Taxonomy Levels' },
        { key: 'sdg', label: 'Sustainable Development Goal' },
      ],
      courseCoverageFields: [
        { key: 'planned_date', label: 'Planned Date' },
        { key: 'planned_session', label: 'Planned Session' },
        { key: 'delivery_method', label: 'Delivery Method Plan' },
        { key: 'po', label: 'Programme Outcome' },
        { key: 'pso', label: 'Programme Specific Outcome' },
        { key: 'bloom', label: 'Blooms Taxonomy Levels' },
        { key: 'sdg', label: 'Sustainable Development Goal' },
        { key: 'tm', label: 'Teaching Methedology' },
      ],
    };
  },
  methods: {
    async getCourseFileHeaderLessonPlan() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/usergroups/setting/${this.usergroup_id}/lessonplan`;
      try {
        const response = await this.$axios.get(url);
        this.lessonplan = Object.assign({}, this.defaultLessonPlan, response.data || {});
        this.backupLessonPlan = JSON.parse(JSON.stringify(this.lessonplan));
      } catch (error) {
        console.error(error);
      }
    },
    async getCourseFileHeaderCourseCoverage() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/usergroups/setting/${this.usergroup_id}/coursecoverage`;
      try {
        const response = await this.$axios.get(url);
        this.coursecoverage = Object.assign({}, this.defaultCourseCoverage, response.data || {});
        this.backupCourseCoverage = JSON.parse(JSON.stringify(this.coursecoverage));
      } catch (error) {
        console.error(error);
      }
    },
    toggleLessonPlanEdit() {
      this.isLessonPlanEditable = true;
    },
    toggleCourseCoverageEdit() {
      this.isCourseCoverageEditable = true;
    },
    cancelLessonPlanEdit() {
      this.lessonplan = JSON.parse(JSON.stringify(this.backupLessonPlan));
      this.isLessonPlanEditable = false;
    },
    cancelCourseCoverageEdit() {
      this.coursecoverage = JSON.parse(JSON.stringify(this.backupCourseCoverage));
      this.isCourseCoverageEditable = false;
    },
    async setLessonPlan() {
      if (this.lessonplan.delivery_method) {
        this.lessonplan.planned_session = true;
      }
      const url = this.$store.getters.getAPIKey.mainAPI + `/usergroups/setting/${this.usergroup_id}/lessonplan`;
      try {
        await this.$axios.post(url, {
          lessonplan: this.lessonplan,
        });
        this.$toast.success("Lesson Plan updated", { position: "top" });
        this.backupLessonPlan = JSON.parse(JSON.stringify(this.lessonplan));
        this.isLessonPlanEditable = false;
      } catch (error) {
        this.$toast.error("Lesson Plan update failed", { position: "top" });
      }
    },
    async setCourseCoverage() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/usergroups/setting/${this.usergroup_id}/coursecoverage`;
      try {
        await this.$axios.post(url, {
          coursecoverage: this.coursecoverage,
        });
        this.$toast.success("Course Coverage updated", { position: "top" });
        this.backupCourseCoverage = JSON.parse(JSON.stringify(this.coursecoverage));
        this.isCourseCoverageEditable = false;
      } catch (error) {
        this.$toast.error("Course Coverage update failed", { position: "top" });
      }
    },
    onLessonPlanChange(key) {
      if (key === 'delivery_method' && this.lessonplan.delivery_method) {
        this.lessonplan.planned_session = true;
      }
    },
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
}
.tile {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  background-color: #f9f9f9;
}
h4 {
  margin-bottom: 12px;
  color: #007bff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.field {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
input[type="checkbox"] {
  margin-right: 10px;
  transform: scale(1.2);
}
</style>
